import React from 'react';
import { connect } from 'react-redux';
import BodyContainer from '../bodyContainer/BodyContainer';
import DataRights from './sub-components/DataRights';
import AppTerms from './sub-components/AppTerms';
import Addendums from './sub-components/Addendum/Addendum'
import './styles/agreeToTerms.scss';
import AuthComponent from '../../../common/AuthComponent';

class AgreeToTerms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDataRightsAccepted: true
    };
  }

  render() {
    return (
      <BodyContainer title={this.props.constants.AGREE_TO_TERMS_TITLE} description={this.props.constants.AGREE_TO_TERMS_DESCRIPTION}>
        <div className="agree-to-terms-body">
          {this.props.captureDataRights && <DataRights {...this.props}/>}
          <AppTerms {...this.props}/>
          <Addendums  disableNextButton={this.props.disableNextButton} {...this.props}/>
        </div>
      </BodyContainer>
    );
  }
}

const mapStateToProps = state => ({
  isCheckDataRightsSignedPending:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isCheckDataRightsSignedPending,
  consentInfo:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.consentInfo,
  captureDataRights:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.captureDataRights,
  constants:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.constants
});

export default connect(mapStateToProps)(AuthComponent(AgreeToTerms));
